// @ts-check
import React from 'react';
import classNames from 'classnames';
import redraft from 'redraft';
import { ContentState } from 'draft-js';
import 'vendors/prism';
import genKey from 'draft-js/lib/generateRandomKey';
import { hashString, unpackRawContent, deprecated } from 'lib/helpers';
import { createBlockRenderers, createEntityRenderers, createInlineRenderers } from './renderers';
import { content2raw } from 'lib';
import loadMathJax from 'lib/editor/DraftEditor/plugins/formulaPlugin/mathjax/loadMathJax';

export class DraftViewer extends React.Component {
	state = {
		componentError: null,
	}

	render() {
		const { className, nested } = this.props;
		const { componentError } = this.state;

		return (
			<div className={nested ? className : classNames('rno-markdown', className)}>
				{componentError || this.getRichContent()}
			</div>
		);
	}

	componentDidMount() {
		// @ts-ignore
		loadMathJax({});
	}

	componentDidCatch(error, info) {
		const componentError = (
			<article style={{ color: 'red', overflow: 'auto' }}>
				<h2>渲染错误</h2>
				<h3>{error.message}</h3>
				<pre>{error.stack}</pre>
				<h3>Error component</h3>
				<pre>{info.componentStack}</pre>
			</article>
		);
		this.setState({ componentError });
	}

	getRichContent() {
		let {
			raw,
			packed,
			content,
			onImageClick,
			handleImageThumbnail = url => url,
			enableImageLazyLoad = false,
			findScrollParent,
			rendererDecorator,
		} = this.props;

		if (!raw) {
			// 兼容老的传法，content 可以是 raw 或者 packed
			if (typeof content === 'string') {
				packed = content;
				deprecated('将 packed 内容传入到 DraftViewer 的 content 的用法已废弃，请使用 packed 传入。');
			}
			else if (typeof content === 'object' && Array.isArray(content.blocks)) {
				raw = content;
				deprecated('将 raw 内容传入到 DraftViewer 的 content 的用法已废弃，请使用 raw 传入。');
			}
			else if (content instanceof ContentState) {
				raw = content2raw(content);
			}
		}

		if (!raw && packed) {
			raw = unpackRawContent(packed);
		}

		if (!isValidRaw(raw)) {
			console.warn('非法的 Raw 格式，将渲染为空：', raw);
			return null;
		}

		rendererDecorator = rendererDecorator || (y => y);

		const renderers = rendererDecorator({
			blocks: createBlockRenderers(),
			inline: createInlineRenderers(),
			entities: createEntityRenderers({
				onImageClick,
				handleImageThumbnail,
				enableImageLazyLoad,
				findScrollParent,
			}),
		});

		// @ts-ignore
		return redraft(guardRaw(raw), renderers);
	}
}

function isValidRaw(raw) {
	return (raw
		&& typeof raw === 'object'
		&& Array.isArray(raw.blocks)
		&& raw.entityMap
		&& typeof raw.entityMap === 'object'
	);
}

function guardRaw(raw) {
	const entityMap = raw.entityMap || {};

	raw.blocks = raw.blocks || [];
	for (let block of raw.blocks) {
		block.key = block.key || genKey();
		block.type = block.type || 'unstyled';
		block.inlineStyleRanges = Array.isArray(block.inlineStyleRanges) ? block.inlineStyleRanges : [];
		block.entityRanges = Array.isArray(block.entityRanges) ? block.entityRanges : [];

		// 图片 block 的 `type` 如果是 `unstyled`，渲染会有问题，需显式转换为 `atomic`
		if (block.type === 'unstyled' && block.entityRanges.length === 1) {
			const entityRange = block.entityRanges[0] || {};
			if (entityMap[entityRange.key] && entityMap[entityRange.key].type === 'IMAGE') {
				block.type = 'atomic';
			}
		}
	}
	return raw;
}



// WEBPACK FOOTER //
// ./lib/viewer/DraftViewer.jsx